
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 160 470","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 255.656V107.35h.606C1.212 93.4 16.515 81.877 34.874 81.877h90.567c17.744 0 32.432 10.312 34.268 23.654v149.79c0 4.241-3.672 8.484-8.565 8.484h-11.63c-4.902 0-9.18-4.243-9.18-8.485V135.85h-6.114v325.648c0 4.848-4.287 8.484-8.574 8.484H94.16c-4.893 0-8.565-3.636-8.565-8.484V269.865H74.72v191.633c0 4.848-3.672 8.484-8.574 8.484H44.66c-4.893 0-8.565-3.636-8.565-8.484V135.85h-6.729v119.47c0 4.241-3.672 8.484-8.574 8.484H9.162c-4.755 0-8.944-4.021-9.162-8.149zM79.542 70.354c-19.58 0-35.488-15.766-35.488-35.168S59.962.018 79.542.018c19.59 0 35.49 15.766 35.49 35.168s-15.9 35.168-35.49 35.168z"}})])
          )
        }
      }
    